import { useState } from 'react';
import { formatTime } from '@meisui/core';
import { isInvalidTimeInput, normalizeTimeInput } from './time-input.js';

/** 生の文字列は画面で保持する。非表示になったセルの不正入力も消さない。 */
export function useTimeDrafts() {
  const [drafts, setDrafts] = useState<Record<string, string>>({});
  return {
    clear: (keys: string[]) =>
      setDrafts((previous) =>
        Object.fromEntries(Object.entries(previous).filter(([key]) => !keys.includes(key))),
      ),
    hasErrors: Object.values(drafts).some(isInvalidTimeInput),
    reset: () => setDrafts({}),
    bind: (key: string, value: number | null, onChange: (value: number | null) => void) => ({
      text: drafts[key] ?? (value === null ? '' : formatTime(value)),
      onTextChange: (text: string) => {
        setDrafts((previous) => ({ ...previous, [key]: text }));
        if (!isInvalidTimeInput(text)) onChange(normalizeTimeInput(text));
      },
    }),
  };
}
